import { Component } from '@mycolorway/tao';
import { closest, matches } from 'next/javascripts/modules/dom';

let currentMember = null;
function getCurrentMember() {
  if (!currentMember) {
    currentMember = {};

    const guid = document.querySelector('input[type="hidden"]#member-guid');
    if (guid) {
      Object.assign(currentMember, {
        guid: guid.value,
        admin: !!document.querySelector('input[type="hidden"]#member-admin'),
        owner: !!document.querySelector('input[type="hidden"]#member-owner'),
        visitor: !!document.querySelector('input[type="hidden"]#member-visitor'),
      });
    }
  }

  return currentMember;
}

Component('tr-access-control', {
  properties: {
    permittedMemberRoles: {
      type: Array,
      default: [],
    },

    permittedMemberGuids: {
      type: Array,
      default: [],
    },

    scopeGuid: {
      type: String,
    },

    scopePermissions: {
      type: Array,
      default: [],
    },

    wrapperSelector: {
      type: String,
    },
  },

  ready() {
    this.checkPermissions();
  },

  checkPermissions() {
    if (!this.parentNode) return;

    if (this.hasPermission()) {
      this.renderAccessContent();
    } else {
      this.renderNoAccessContent();
    }
  },

  hasPermission() {
    if (!this.getCurrentMember().guid) return false;
    if (this.isPermitted()) return true;

    if (this.scopeGuid && this.scopePermissions.length > 0) {
      const permissions = this.getPermissions();
      return this.scopePermissions.some(p => permissions.indexOf(p) !== -1);
    }

    return false;
  },

  isPermitted() {
    const me = this.getCurrentMember();
    if (!me.guid) return false;

    let permitted = false;

    if (this.permittedMemberRoles.length > 0) {
      const role = ['admin', 'visitor'].find(r => !!me[r]) || 'normal';
      permitted = this.permittedMemberRoles.indexOf(role) !== -1;
    }

    if (!permitted && this.permittedMemberGuids.length > 0) {
      permitted = this.permittedMemberGuids.indexOf(me.guid) !== -1;
    }

    return permitted;
  },

  renderAccessContent() {
    const accessContent = [...this.children]
      .filter(child => matches(child, '[data-access]'))
      .map(child => (matches(child, 'template') ? this.createElementFromString(child.dataset.template) : child));
    const children = document.createDocumentFragment();

    [...accessContent].forEach(child => children.appendChild(child));
    this.parentNode.replaceChild(children, this);
  },

  createElementFromString(html) {
    const template = document.createElement('template');
    template.innerHTML = html;
    return template.content.firstChild;
  },

  renderNoAccessContent() {
    const noAccessContent = [...this.children]
      .filter(child => matches(child, '[data-no-access]'))
      .map(child => (matches(child, 'template') ? this.createElementFromString(child.dataset.template) : child));

    if (noAccessContent.length > 0) {
      const children = document.createDocumentFragment();

      [...noAccessContent].forEach(child => children.appendChild(child));
      this.parentNode.replaceChild(children, this);
    } else {
      const content = this.wrapperSelector
        ? (closest(this, this.wrapperSelector) || this) : this;
      if (content.parentNode) content.parentNode.removeChild(content);
    }
  },

  getCurrentMember() {
    if (window.gon && window.gon.me) return window.gon.me;
    if (window.tower && window.tower.me) return window.tower.me;
    return getCurrentMember();
  },

  getPermissions() {
    let permissions = {};

    if (window.gon && window.gon.permissions) {
      permissions = { ...window.gon.permissions };
    } else if (window.tower && window.tower.permissions) {
      permissions = { ...window.tower.permissions };
    }

    const rolePermissions = permissions.roles[permissions.scopes[this.scopeGuid]] || [];
    return rolePermissions.map(p => p.split('.').slice(1).join('.'));
  },

  permissionChecked() {
    return new Promise((resolve) => {
      const resolvePromise = () => {
        this.addEventListener('tr-access-control:disconnected', resolve, { once: true });
      };

      if (this.taoStatus === 'connected') {
        resolvePromise();
      } else {
        this.addEventListener('tr-access-control:connected', resolvePromise, { once: true });
      }
    });
  },
});
